export let standardSynonyms = [
  {
    name: 'да',
    words: ['да', 'да-да', 'да да', 'дада', 'ну да', 'согласен', 'ага', 'угу', 'конечно', 'верно', 'так точно', 'да-да-да', 'да да да', 'дадада', 'ok']
  },
  {
    name: 'нет',
    words: ['нет', 'неа', 'нео', 'neo', 'не надо', 'не нужно', 'не хочу', 'ни за что', 'ни в коем случае', 'не хотим', 'не можем']
  }
]



// WEBPACK FOOTER //
// ./client/views/scenarios/konstruktor/standardSynonyms.js